const AUTH_TOKEN_KEY = "authToken";
const GET_TOKEN_FAILURE_COUNT_KEY = "getTokenFailureCount";
const GET_TOKEN_FAILURE_MAX_RETRY_COUNT = 4;
const GET_KMSI_FAILURE_COUNT_KEY = "getKmsiFailureCount";
const GET_KMSI_FAILURE_MAX_RETRY_COUNT = 2;
export {
  AUTH_TOKEN_KEY,
  GET_KMSI_FAILURE_COUNT_KEY,
  GET_KMSI_FAILURE_MAX_RETRY_COUNT,
  GET_TOKEN_FAILURE_COUNT_KEY,
  GET_TOKEN_FAILURE_MAX_RETRY_COUNT
};
